// Copyright © Veeam Software Group GmbH

import type { RESTRestorePoint } from 'api/rxjs';

export function doesDateHaveRestorePoints(date: Date, restorePoints: RESTRestorePoint[]) {
    const restorePointDates = [...new Set(restorePoints.map(p => new Date(p.backupTime).toLocaleDateString()))];

    return date.getTime() > Date.now() || !restorePointDates.includes(date.toLocaleDateString());
}
